import { useEffect, useState } from 'react'
import { Box, Card, Button, Title, Text, Stack, Alert } from '@mantine/core'
import { IconAlertCircle, IconBrandWindows } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import {
  clearPrismAuth,
  isMsalAuthenticated,
  loginWithMicrosoft,
} from '../../api/msal'
import { isAllowedSsoUser } from '../../api/allowlist'
import logo from '../../assets/prism_logo_tagline.svg'

export function SignIn() {
  const navigate = useNavigate()
  const [ssoLoading, setSsoLoading] = useState(false)
  const [ssoError, setSsoError] = useState<string | null>(null)

  useEffect(() => {
    // If the user lands here with stale localStorage markers but no active
    // MSAL account, clear them so they must sign in again.
    isMsalAuthenticated().then((ok) => {
      if (ok) {
        navigate('/')
      } else {
        clearPrismAuth()
      }
    })
  }, [navigate])

  const handleMicrosoftLogin = async () => {
    setSsoLoading(true)
    setSsoError(null)
    try {
      const account = await loginWithMicrosoft()

      const allowed = await isAllowedSsoUser(account.username)
      localStorage.setItem('prism_auth_method', 'microsoft')
      localStorage.setItem('prism_username', account.username)
      localStorage.setItem('prism_allowlisted', allowed ? 'true' : 'false')
      if (account.name) {
        localStorage.setItem('prism_display_name', account.name)
      } else {
        localStorage.removeItem('prism_display_name')
      }
      navigate('/')
    } catch {
      setSsoError('Microsoft sign-in failed or was cancelled.')
      setSsoLoading(false)
    }
  }

  return (
    <Box
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%)',
      }}
    >
      <Card w={560} p="xl" radius="lg" withBorder bg="#1a1a1a">
        <Stack align="center" gap="lg">
          <img
            src={logo}
            alt="Prism logo"
            style={{ width: 500, height: 'auto', marginBottom: -16 }}
          />
          <Box style={{ textAlign: 'center' }}>
            <Title order={2} c="white">
              Welcome to Prism
            </Title>
            <Text size="sm" c="gray.4">
              Sign in with your Microsoft account to continue
            </Text>
          </Box>

          <Stack w="100%" gap="md">
            {ssoError && (
              <Alert
                icon={<IconAlertCircle size={16} />}
                color="red"
                variant="light"
              >
                {ssoError}
              </Alert>
            )}

            <Button
              fullWidth
              size="md"
              variant="default"
              leftSection={<IconBrandWindows size={20} />}
              onClick={handleMicrosoftLogin}
              loading={ssoLoading}
            >
              Sign in with Microsoft
            </Button>
          </Stack>
        </Stack>
      </Card>
    </Box>
  )
}
